import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const CommonCenterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 auto',
  padding: theme.spacing(2)
}));

CommonCenterContainer.propTypes = {
  children: PropTypes.node,
};

export default CommonCenterContainer;